/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6fedc000"]'><cube-button open-type="launchApp" app-parameter="xxx" tip="需在微信小程序环境预览" @launchApp='(e)=>__invoke(e, [["onLaunchApp"]])'>打开 APP</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6fedc000"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6fedc000"}
  /** script content **/
  require("./btn-launch-app.mpx.js?isComponent&outputPath=components%2Fbtn-launch-app6fedc000%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-launch-app.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-launch-app6fedc000%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6fedc000"],
    ctorType: "component",
    outputPath: "components/btn-launch-app6fedc000/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>